import { popup } from "@core/gql-mockups/CRMs";

const { minimize_str } = require("@core/helpers/string");

export const GET_POPUPS_BY_KEYS = ({ popup_mockup }) => minimize_str(`
  query ($keys: [String]) {
    result: getPopupsByKeys(keys: $keys) ${popup_mockup || popup}
  }
`);
